import React from 'react'
import { Box, Grid, makeStyles } from '@material-ui/core'
import MyTextfield from '../../../../control/textfield/textfield'
import MyButton from '../../../../control/button/button'
import useTranslate from '../../../../i18n/useTranslate'

const ProjectRow: React.FC<{ namePrefix: string; canEdit?: boolean; onRemove?: () => void }> = ({
    namePrefix,
    canEdit = true,
    onRemove,
}) => {
    const classes = useStyles()
    const t = useTranslate()

    return (
        <Box className={classes.rowCard}>
            <Grid container spacing={2} alignItems="flex-start">
                <Grid item xs={12}>
                    <MyTextfield
                        name={`${namePrefix}.projectNumber`}
                        resetButtom
                        materialInputProps={{
                            label: t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_ID'),
                            placeholder: t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_ID'),
                            disabled: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <MyTextfield
                        name={`${namePrefix}.projectDescription`}
                        resetButtom
                        rowsMin={7}
                        materialInputProps={{
                            label: t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_CONSIDERATION'),
                            placeholder: t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_CONSIDERATION'),
                            disabled: !canEdit,
                            multiline: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <MyTextfield
                        name={`${namePrefix}.projectSummary`}
                        resetButtom
                        materialInputProps={{
                            label: t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_COMMENT'),
                            placeholder: t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_COMMENT'),
                            disabled: !canEdit,
                            multiline: true,
                            rows: 3,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <div className={classes.rightEnd}>
                        {onRemove && (
                            <MyButton onClick={onRemove} color="secondary" disabled={!canEdit} style={{ minWidth: 80 }}>
                                {t.get('BUTTON.DELETE')}
                            </MyButton>
                        )}
                    </div>
                </Grid>
            </Grid>
        </Box>
    )
}

const useStyles = makeStyles((theme) => ({
    rowCard: {
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: theme.spacing(2),
        marginTop: 16,
    },
    rightEnd: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8 },
}))

export default React.memo(ProjectRow)
